<script>
import * as moment from 'moment'
import LayerBatchChooser from '@/layer/components/LayerBatchChooser.vue'
import LayerPersonChooser from '@/layer/components/LayerPersonChooser.vue';

function createWeights() {
  let weights = [];
  for (let i = 1; i <= 40; i++) {
    weights.push({
      number: i,
      weightKg: 0,
    });
  }
  return weights;
}

export default {
  components: {
    LayerBatchChooser,
    LayerPersonChooser,
  },

  data: () => ({
    batchName: '',
    date: moment().format('YYYY-MM-DD'),
    person: '',
    weights: createWeights(),
  }),

  computed: {
    validationError() {
      if (!this.batchName) return 'Please choose a Batch';
      if (!this.date) return 'Please choose a Placed Date';
      if (!this.person) return 'Please choose a Person';
      if (this.weights.find(x => !x.weightKg || Number(x.weightKg) <= 0)) return 'Please fill in all weights';

      return undefined;
    },

    submitPayload() {
      let weightsDict = {};
      this.weights
        .filter(x => x.weightKg > 0)
        .forEach(x => { weightsDict[Number(x.number)] = Number(x.weightKg) });

      return {
        date: this.date,
        person: this.person,
        weights: weightsDict,
      };
    },
  },

  methods: {
    clearForm() {
      this.batchName = '';
      this.date = moment().format('YYYY-MM-DD');
      this.person = '';
      this.weights.forEach(x => { x.weightKg = 0 });
    },

    onFormSubmitSuccess(newRecord) {
      this.clearForm();
    },

    onCancelledForm() {
      this.$router.push({ name: 'form-cancelled' });
    },
  },
}
</script>

<template>

  <b-card>
    <api-form
      method="post"
      :url="`v1/layers/batches/${encodeURIComponent(batchName)}/chicken-weight-records`"
      :payload="submitPayload"
      submit-text="Add"
      :validation-error="validationError"
      :make-success-message="() => `Chicken weight record was successfully added on ${date}.`"
      @success="onFormSubmitSuccess"
      @cancel="onCancelledForm">

      <slot name="above-header"></slot>

      <h4 class="text-center mt-0">Add Chicken Weight Record</h4>

      <layer-batch-chooser v-model="batchName" mode="chicken_weight" required />

      <transition name="fade">
        <div v-if="batchName">
          <b-form-group label="Date" :label-for="`date-${_uid}`">
            <b-form-input :id="`date-${_uid}`" v-model="date" type="date" placeholder="Date..." required></b-form-input>
          </b-form-group>

          <layer-person-chooser v-model="person" required />

          <label class="font-weight-bold">Chicken Weights</label>
          <b-input-group v-for="weight in weights" :key="weight.number" class="mb-1" size="sm">
            <b-input-group-text slot="prepend">
              <div style="width:30px"> {{weight.number}} </div>
            </b-input-group-text>

            <b-form-input
              :id="`weight-${_uid}`"
              v-model="weight.weightKg"
              type="number"
              step="any"
              placeholder="Weight..."
              required
              @focus="$event.target.select()"></b-form-input>

            <b-input-group-text slot="append"> kg </b-input-group-text>
          </b-input-group>

          <div class="mt-5"></div>
        </div>
      </transition>

    </api-form>

  </b-card>
</template>



// WEBPACK FOOTER //
// src/layer/components/AddChickenWeightRecord.vue